import React from 'react';
import Scan from './Scan/Scan';
import Box_black from './box.svg';
import Box_grey from './box1.svg';
import Box_white from './box2.svg';
import './Scans.css';
import Fade from 'react-reveal/Fade';

const scans = () => {
    return (
        <div className="scans">
            <div className="container-fluid bg-1">
                <div className="main">
                    <Fade delay={250}>
                        <span className="content"> Type of  </span>
                    </Fade>
                    <Fade delay={500}>
                        <span className="content1"> Wise Scan  </span>
                    </Fade>
                </div>
                <Scan className="class1" src={Box_black} name="Black Box (DAST)" content=" Probe applications by simulating the attack methods of hackers, identifying vulnerabilities by analyzing unexpected results." />
                <Scan className="class2" src={Box_grey} name="Grey Box (DAST)" content=" It allows testers to prioritize tests based on an understanding of the target system, potentially uncovering more significant vulnerabilities with less effort and cost." />
                <Scan className="class3" src={Box_white} name="White Box (DAST)" content="Get a prioritized list of vulnerabilities based on severity, address the most significant flaws first and avoid dealing with hundreds of false positives. " />
            </div>
        </div>
    )
}

export default scans;